export const candidatePortalRedirectUrls = {
  CANDIDATE_MATCHES: '/candidate/matches',
  MATCH_ARCHIVE: '/candidate/match-archive',
  CANDIDATE_PORTAL: '/candidate',
};
